function isObjectLike(value) {
  return value != null && typeof value == "object";
}
export {
  isObjectLike as default
};
